import {Spin} from "antd"
import {chartSchema} from 'apis/chart'
import ErrorBoundary from 'components/error/ErrorBoundary'
import ChartSvg from 'components/Svgs/ChartSvg'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from "react-router-dom"
import {useSelectEntities} from 'redux/entities/useSelectEntities'
import {ChartProvider, PremiumChartProvider, TableChartProvider} from '../ChartContext'
import ChartWrapper from './ChartWrapper/ChartWrapper.lazy'
import DetailChartWrapper from './ChartWrapper/DetailChartWrapper.lazy'
import GoogleChart from './GoogleChart'
import PremiumChartHolder from './PremiumChartHolder/PremiumChartHolder.lazy'
import StatisticTable from './StatisticTable'
import {NullAsDefault} from "../../Shared";

const AmChart = React.lazy(() => import('./AmChart'))
const AmGeoChart = React.lazy(() => import('./AmGeoChart'))
const AmPieChart = React.lazy(() => import('./AmPieChart'))
const AmUSGeoChart = React.lazy(() => import('./AmUSGeoChart'))
const AmVNGeoChart = React.lazy(() => import('./AmVNGeoChart'))
const AntTable = React.lazy(() => import('./AntTable'))

export const ChartStateless = ({
                                   header = NullAsDefault,
                                   item,
                                   CWrapper = ChartWrapper,
                                   ...props
                               }) => {
    const t = useTranslate()
    let chartElement = null
    if (!item) return (
        <CWrapper {...props}>
            <div className="relative h-48 flex justify-center items-center flex-col space-y-4 my-auto">
                {!!!props.hideIcon && (
                    <div className="h-32 inset-0 opacity-25 opacity-50">
                        <ChartSvg
                            width="100%"
                            height="100%"/>
                    </div>
                )}
                <Spin size={"large"}/>
            </div>
        </CWrapper>
    );
    if (!!item.login_required) {
        return (
            <ChartProvider item={item}>
                <CWrapper {...props}>
                    <div className="relative h-48 flex justify-center items-center flex-col space-y-4 my-auto">
                        <div className="h-32 inset-0 opacity-25">
                            <ChartSvg
                                width="100%"
                                height="100%"/>
                        </div>
                        <h3 className="text-center opacity-75">
                            {t('Please login to view this content')}
                        </h3>
                        <div className="flex items-center justify-center">
                            <Link
                                to={'/login'}
                                className="border rounded-full px-6 py-2 bg-primary text-white">
                                {t('Login now')}
                            </Link>
                        </div>
                    </div>
                </CWrapper>
            </ChartProvider>
        )
    }
    if (item.data_empty) {
        return (
            <ChartProvider item={item}>
                <CWrapper {...props}>
                    <div className="relative h-48 flex justify-center items-center flex-col space-y-4 my-auto">
                        <div className="h-32 inset-0 opacity-25">
                            <ChartSvg
                                width="100%"
                                height="100%"/>
                        </div>
                        <h3 className="text-center font-bold text-xl opacity-75">
                            {t('no data found')}
                        </h3>
                    </div>
                </CWrapper>
            </ChartProvider>
        )
    }
    switch (true) {
        case item.subscribe_required:
            chartElement = (
                <PremiumChartProvider
                    item={item}>
                    <CWrapper {...props}>
                        <PremiumChartHolder
                            {...props}
                        />
                    </CWrapper>
                </PremiumChartProvider>
            )
            break

        case item.chart_source ===
        'GoogleChart' &&
        item.chart_type === 'Table':
            chartElement = (
                <TableChartProvider item={item}>
                    <CWrapper {...props}>
                        <GoogleChart {...props} />
                    </CWrapper>
                </TableChartProvider>
            )
            break
        case item.chart_source ===
        'AntDesign' &&
        item.chart_type === 'Table':
            chartElement = (
                <TableChartProvider item={item}>
                    <CWrapper {...props}>
                        <AntTable {...props} />
                    </CWrapper>
                </TableChartProvider>
            )
            break;
        case item.chart_source ===
        'Statistic' &&
        item.chart_type === 'Table':
            chartElement = (
                <TableChartProvider item={item}>
                    <CWrapper {...props}>
                        <StatisticTable {...props} />
                    </CWrapper>
                </TableChartProvider>
            )
            break
        case item.chart_source ===
        'GoogleChart':
            chartElement = (
                <ChartProvider item={item}>
                    <CWrapper {...props}>
                        <GoogleChart {...props} />
                    </CWrapper>
                </ChartProvider>
            )
            break
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'VNGeoChart':
            chartElement = (
                <ChartProvider item={item}>
                    <CWrapper {...props}>
                        <AmVNGeoChart {...props} />
                    </CWrapper>
                </ChartProvider>
            )
            break
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'USGeoChart':
            chartElement = (
                <ChartProvider item={item}>
                    <CWrapper {...props}>
                        <AmUSGeoChart {...props} />
                    </CWrapper>
                </ChartProvider>
            )
            break
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'GeoChart':
            chartElement = (
                <ChartProvider item={item}>
                    <CWrapper {...props}>
                        <AmGeoChart {...props} />
                    </CWrapper>
                </ChartProvider>
            )
            break
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'PieChart':
            chartElement = (
                <ChartProvider item={item}>
                    <CWrapper {...props}>
                        <AmPieChart {...props} />
                    </CWrapper>
                </ChartProvider>
            )
            break
        case item.chart_source ===
        'AmChart':
            chartElement = (
                <ChartProvider item={item}>
                    <CWrapper {...props}>
                        <AmChart {...props} />
                    </CWrapper>
                </ChartProvider>
            )
            break
        default:
            break
    }
    return (
        <ErrorBoundary
            fallbackComponent={() => {
                return (
                    <div className="w-full h-full flex justify-center items-center font-bold text-color-300 text-2xl">
                        Error
                    </div>
                )
            }}>
            {chartElement}
        </ErrorBoundary>
    )
}

export const Chart = ({
                          id,
                          ...props
                      }) => {
    const item = useSelectEntities(
        id,
        chartSchema,
        {}
    )

    return (
        <ChartStateless
            item={item}
            CWrapper={
                props.detail
                    ? DetailChartWrapper
                    : ChartWrapper
            }
            {...props}
        />
    )
}

export const GetChartComponent = ({
                                      header = NullAsDefault,
                                      width,
                                      height,
                                      item,
                                      ...props
                                  }) => {
    switch (true) {
        case item.subscribe_required:
            return (
                <PremiumChartHolder
                    {...props}
                />
            )

        case item.chart_source ===
        'GoogleChart' &&
        item.chart_type === 'Table':
            return <GoogleChart {...props} />
        case item.chart_source ===
        'AntDesign' &&
        item.chart_type === 'Table':
            return <AntTable {...props} />
        case item.chart_source ===
        'Statistic' &&
        item.chart_type === 'Table':
            return <StatisticTable {...props} />
        case item.chart_source ===
        'GoogleChart':
            return <GoogleChart {...props} />
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'VNGeoChart':
            return <AmVNGeoChart {...props} />
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'USGeoChart':
            return <AmUSGeoChart {...props} />
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'GeoChart':
            return <AmGeoChart {...props} />
        case item.chart_source ===
        'AmChart' &&
        item.chart_type === 'PieChart':
            return <AmPieChart {...props} />
        case item.chart_source ===
        'AmChart':
            return <AmChart {...props} />
        default:
            return null
    }
}
export default React.memo(Chart)
